// @flow

import LayoutElement from './LayoutElement';

export default class StatusLayout {
  columns: number = 1;

  rows: number = 1;

  selectedViewIndex: number = 0;

  viewsGroup: Array<number> = [0];

  elements: Array<LayoutElement> = [];
}
